import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlPathnameEnum } from '@enums/url-pathname.enum';
import { ChatDeskService } from '@shared/services/chat-desk/chat-desk.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  @Input() code: number;
  @Input() title: string;
  @Input() message: string;
  @Input() mainPageBtn: boolean;
  @Input() backBtn: boolean;
  @Input() loginPageBtn: boolean;
  errMessage: string;

  constructor(
    @Inject(Router) private _router: Router,
    @Inject(ActivatedRoute) private _route: ActivatedRoute,
    @Inject(ChatDeskService) private chatDeskService: ChatDeskService
  ) {}

  ngOnInit(): void {
    this.errMessage = this._route.snapshot.queryParams?.message;
  }

  navigateToLoginPage(): void {
    this._router.navigate([UrlPathnameEnum.Login], { queryParams: { checkAuthorized: 'true' } });
    this.chatDeskService.logoutFromFreshChat();
  }

  navigateToMainPage(): void {
    this._router.navigate(['/']);
  }
}
